import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'customSplit' })
export class CustomSplitPipe implements PipeTransform {
  transform(value: string, splitter: string): string {
    const split = value?.split(splitter);
    if(!split.length){
        return value;
    }

    value = split[split.length - 1] || '';
    return value ;
  }
}
